import * as notificationActions from 'services/notifications/actions'

export const notificationMiddleware = (store) => (next) => (action) => {
  if (action.hasOwnProperty('meta')) {
    if (action.type.indexOf('_ERROR') !== -1 && action.meta.globalErrorNotification) {
      store.dispatch(notificationActions.triggerGlobalApiFailureNotification())
    }
  }

  next(action)
}
